export default "__VITE_ASSET__D32$Yyyc__"